import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CustomRMAService, ReturnRMAData } from "@tSurya/Services/CustomRMAService";

type SubmitCustomSubmitOrder = HasOnSuccess & ReturnRMAData & HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<SubmitCustomSubmitOrder, ReturnRMAData, any>;

const CustomPopulateApiParameter: CustomHandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

const CustomSendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await CustomRMAService(props.apiParameter);
        props.apiResult = {
            success: true,
            result,
        };
    } catch (err: any) {
        let errorMessage = "";
        if (err?.errorMessage.includes("Content:")) {
            const json = err.errorMessage.substring(err.errorMessage.indexOf("Content:") + "Content:".length).trim();

            const parsed = JSON.parse(json);
            if (parsed?.ErrorMessage) {
                errorMessage = parsed.ErrorMessage;
            }
        }
        props.apiResult = {
            success: false,
            errorMessage,
        };
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (props.apiResult.error) {
        props.parameter.onError?.();
    }
};

export const chain = [
    CustomPopulateApiParameter,
    CustomSendDataToApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
];

const CustomRMARequest = createHandlerChainRunner(chain, "CustomRMARequest");
export default CustomRMARequest;
